<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M8.36,787.85l-9.62,9.62l-3.21-3.21l9.62-9.62l5.35-2.14L8.36,787.85z M-2.7,794.95l0.76,0.76l5.34-5.34l-0.76-0.76
	L-2.7,794.95z M-7.99,802.5l6.42-6.41l-1.51-1.51l-6.42,6.41L-7.99,802.5z M-6.29,793.95l5.35,5.35l1.51-1.51l-5.35-5.35
	L-6.29,793.95z"/>
</svg>

</template>